import React, { useState, useEffect, useRef, useCallback } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import ShopStore from '../DataRepo/ShopStore';
import { CircularProgress, Button, IconButton, Badge } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { ChevronLeft } from '@mui/icons-material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { shopModel } from '../Axios/AxiosConfig';
import WishlistStore from '../DataRepo/WishlistStore';
import useCartStore from '../DataRepo/CartStore';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import addtocart from '../Assets/images/add_to _bag_brown.png'
import searchicon from '../Assets/images/search icon-black.png';
import loadingimg from '../Assets/images/loading image 1.png'
import { getUserDetails } from '../Auth/AuthUtil';

function AllProducts() {

    const { Products, getProducts, isLoading, getProductsByType, page, setPage } = ShopStore();

    const { addWishlist, WishlistItems, isWishlistLoading, removeWishlist, getWishlistItems } = WishlistStore()

    const [selectedCategory, setSelectedCategory] = useState("");

    const userDetails = getUserDetails();

    const { addItem, cartItems, updateQuantity, decreaseQuantity, removeItem, getCart } = useCartStore();

    const [wellnessCategory, setWellnessCategory] = useState('');

    const navigate = useNavigate();

    const location = useLocation();

    const [posts, setPosts] = useState([]);

    const [loading, setLoading] = useState(false);

    const observer = useRef();

    const lastPostElementRef = useCallback(
        (node) => {
            if (loading) return;
            if (observer.current) observer.current.disconnect();

            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    setPage();
                }
            });

            if (node) observer.current.observe(node);
        },
        [loading]
    );

    const loadMoreProducts = async () => {
        setLoading(true);
        getProducts()
        setLoading(false);
    };

    useEffect(() => {
        if (selectedCategory === "All" && wellnessCategory === '') {
            loadMoreProducts()
        }
    }, [page, selectedCategory, wellnessCategory]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const category = queryParams.get('category') || '';
        const type = queryParams.get('type') || 'All'
        setWellnessCategory(category.trim());
        setSelectedCategory(type);
        getWishlistItems()
        getCart()
    }, [location]);

    useEffect(() => {
        if (selectedCategory === "All" && wellnessCategory === '') {
            getProducts();
        } else {
            getProductsByType(selectedCategory, wellnessCategory);
        }
    }, [selectedCategory, wellnessCategory]);

    const Categories = [
        { name: "All", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/all_product_icon.png", type: "All" },
        { name: "Tablets", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Tablets.png", type: "Tablets" },
        { name: "Powders", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Powders.png", type: "Churna" },
        { name: "Oils", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Oils.png", type: "Oil" },
        { name: "Ghee", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Ghee.png", type: "Ghee" },
        { name: "Decoctions", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Decoctions.png", type: "Kashayam (Decoctions)" },
        { name: "Fermented", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Fermented.png", type: "Arishta" },
        { name: "Miscellaneous", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Miscellaneous.png", type: "Miscellaneous" },
        { name: "Syrups", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Syrups.png", type: "Syrup" },
        { name: "Tea", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Tea.png", type: "Tea" }
    ];

    const addtoCart = (item, id) => {

        const price = parseInt(item?.price)

        const desc = item?.desc

        const qty = item?.qty

        let product = {
            id: id,
            productName: item?.name,
            quantity: 1,
            price,
            desc,
            companyid: item?.company_id,
            deliverycharges: item?.deliverycharges,
            src: item?.imgurl,
            actualQty: qty,
            sku: item?.sku,
            company: item?.company
        };

        addItem(product, userDetails?.UID)
    };

    return (
        <div className='All-products-section-main'>
            <nav className='flex flex-row p-2 items-center justify-between'>
                <div className='flex items-center gap-2'>
                    <IconButton onClick={() => navigate(-1)}>
                        <ChevronLeft />
                    </IconButton>
                    <p>Products</p>
                </div>

                <div className='flex flex-row items-center'>


                    <IconButton component={Link} to="/Search">
                        <div className='nav-icons'>
                            <img src={searchicon} alt="Search" />
                        </div>
                    </IconButton>

                    <IconButton component={Link} to="/Checkout">
                        <Badge badgeContent={cartItems?.length} color="error">
                            <div className='nav-icons'>
                                <img src={addtocart} alt="Cart" />
                            </div>
                        </Badge>
                    </IconButton>



                    <IconButton component={Link} to="/wishlist">
                        {WishlistItems.length > 0 ? (
                            <FavoriteIcon style={{
                                color: "#DA6E0B"
                            }} />
                        ) : (
                            <FavoriteBorderIcon />
                        )}
                        
                    </IconButton>
                </div>

            </nav>

            <div className="All-products-section">
                <div className='ListofCategories'>
                    {Categories.map((e) => (
                        <div key={e.type} onClick={() => setSelectedCategory(e.type)}>
                            <img
                                src={e.img}
                                style={selectedCategory === e.type ? { border: "1px solid #DA6E0B" } : {}}
                                alt={e.name}
                            />
                            <p>{e.name}</p>
                        </div>
                    ))}
                </div>
                
                <div className="RecommendedProduct-container">
                    {Products.map((product, i) => (
                        
                        <div key={i} className="Product-section-card"
                            ref={lastPostElementRef}
                            onClick={() => {
                                navigate(`/Product?id=${product.id}`)
                            }}
                        >
                            <div className="Product-card-header">
                                <div className="Product-discount-badge">
                                    {product.orgprice > 0 && product.price && product.orgprice != product.price ? (
                                        <p>
                                            {(((parseFloat(product.orgprice) - parseFloat(product.price)) / parseFloat(product.orgprice)) * 100).toFixed(0) + "% off"}
                                        </p>
                                    ) : null}
                                </div>

                                <div className="Product-wishlist-icon">
                                    <IconButton
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            {
                                                WishlistItems.some((item) => item.id === product?.id) ? (
                                                    removeWishlist(product.id)
                                                ) : (
                                                    addWishlist(product.id)
                                                )
                                            }
                                        }}
                                    >
                                        {WishlistItems.some((item) => item.id === product?.id) ? (
                                            <FavoriteIcon style={{
                                                color: "#DA6E0B"
                                            }} />
                                        ) : (
                                            <FavoriteBorderIcon />
                                        )}
                                    </IconButton>
                                </div>

                            </div>
                            <div>
                                <img src={product?.imgurl || loadingimg
                                } alt={product.name} style={{ width: '100%', borderRadius: '10px' }} />
                            </div>

                            <div className='Product-section-card-title'>
                                <p>{product?.name}</p>
                                <p>{product?.desc}</p>
                            </div>

                            <div className='Addtobagbutton'>
                                <div className='Product-section-price-details'>
                                    {product?.orgprice > 0 && product?.orgprice != product?.price &&
                                        <p className='mr-5' style={{ fontSize: "16px" }}><del>{`₹ ${product?.orgprice}`}</del></p>}
                                    <p style={{ fontSize: "18px" }}>₹ {product?.price}</p>
                                </div>

                                <div className='w-100'>
                                    <Button
                                        style={{
                                            width: '100%',
                                            display: "block",
                                            textTransform: 'none',
                                            backgroundColor: product.onsale ? '#75623F' : '#D9d9d9',
                                            color: product.onsale ? 'white' : "#A5A39D",
                                            border: 'none',
                                            boxSizing: 'border-box',
                                            borderRadius: "5px",
                                            fontFamily: "'Poppins', sans-serif",
                                            fontWeight: 500,
                                            // padding: "5px"
                                        }}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            if (product.onsale) {
                                                const existingItem = cartItems?.find(cartItem => cartItem?.id === product.id);
                                                const id = product?.id
                                                !existingItem && addtoCart(product, id)
                                            }

                                        }}
                                    >
                                        <div className="addtobagctn w-100">
                                            {(() => {

                                                if (product.onsale) {
                                                    const existingItem = cartItems?.find(cartItem => cartItem?.id === product.id);
                                                    return (
                                                        <div>
                                                            {existingItem ? (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        width: "100%",
                                                                        justifyContent: "space-evenly",
                                                                    }}
                                                                >
                                                                    <RemoveIcon
                                                                        style={{ cursor: "pointer" }}
                                                                        fontSize='small'
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();

                                                                            const id = product?.id?.toString() || product?.id;

                                                                            existingItem.quantity <= 1 ?
                                                                                removeItem(id) : decreaseQuantity(id, userDetails?.UID);
                                                                        }}
                                                                    />
                                                                    <span>{existingItem.quantity}</span>
                                                                    <AddIcon
                                                                        style={{ cursor: "pointer" }}
                                                                        fontSize='small'
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            const id =
                                                                                product?.id?.toString() || product?.id;
                                                                            updateQuantity(id, userDetails?.UID);
                                                                        }}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <p>Add to Bag</p>
                                                            )}
                                                        </div>
                                                    );
                                                } else {
                                                    return <p>Coming Soon</p>;
                                                }
                                            })()}
                                        </div>

                                    </Button>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>

                {isLoading &&
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <CircularProgress style={{
                            color: "#DA6E0B"
                        }} />
                    </div>
                }
            </div>
        </div>
    );

}

export default AllProducts;